import { DEV_API_FLAG } from "./common/API";
import { apiServerHost } from "./common/APIServerSettings";
import Axios from "axios";

export default (callBackFunc, responseID) => {
  const params = new URLSearchParams();
  params.append("responseID", responseID);

  Axios.post(apiServerHost + `/manage/topic/builder${DEV_API_FLAG ? '/dev' : ''}/delete/response`,params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  });
}